/*
 * Copyright (c) 2025. Orion Analytics. All Rights Reserved
 */

import React, { useContext,useState } from "react";
import { StockContext } from "./stock_context";
import Stockchart from "../stockchart_plotly";
import DisplayCards from "../metricCards";
import DynamicStockCharts from "../dynamicStockCharts_plotly";
import FundaTeaser from "../fundamentals/stockFundamentalTeaser";
import Plot from "react-plotly.js";

function StockSnapshot({data,ticker}) {
    console.log("PRICE Columns",data)
    // Convert to list of dictionaries
    let price_json = JSON.parse(data.price_list)
        console.log("PRICE price_json",price_json)

    // if (!data || !data.columns || !data.data || !data.data[0]) {
    if (!price_json || !price_json.columns || !price_json.data || !price_json?.data[0]) {
            // console.log("PRICE LIST",data)
                    console.log("PRICE Columns 1",price_json.columns)
            // console.log("PRICE DATA",data[0])
            // console.log("PRICE LIST",data)

        return <p>Loading stock data...</p>;
    }
    const price_list = price_json?.columns.map((column, index) => ({
      title: column,
      // value: data.data[0][index],
      value: price_json.data[0][index],
      change: null
    }));
    return(
        <div>
        <DisplayCards cardList={price_list} color={"#0b5585"}/>
        <FundaTeaser symbol={ticker}/>
            <div className="container py-5">

            <div className="row g-4">
        <h4>News</h4>
            {Array.isArray(data?.news) && data.news.map((newsitem, index) => (
              <div key={index} className="col-md-6 col-lg-3 wow fadeInUp" data-wow-delay="0.6s">
                <div className="service-item">
                  <p className="px-3 py-2">
                      {/*{newsitem[0]}*/}
                    {new Date(newsitem[0]).toISOString().split("T")[0]}
                  </p>
                  <a href={newsitem[1]} className="h5 d-inline-block mb-4 px-3" target="_blank" rel="noopener noreferrer">
                    {newsitem[2]}
                  </a>
                </div>
              </div>
            ))}
        </div>
        </div>
        </div>
    );
}

function StockGraph({data}) {
    return(
    <Stockchart symbol={data} volume={true} bbFlag={true} levelFlag={true}/>
    );
}
function Benchmarks({data,ticker}) {
    // Convert to list of dictionaries
    if (!data || !data.columns || !data.data || !data.data[0]) {
            // console.log("PRICE LIST",data)
                    console.log("PRICE Columns",data.columns)
            // console.log("PRICE DATA",data[0])
            // console.log("PRICE LIST",data)

        return <p>Loading stock data...</p>;
    }
    const price_list = data?.columns.map((column, index) => ({
      title: column,
      value: data.data[0][index],
      change: null
    }));
    return (
        <div>
            <p>Period Performance</p>
        <DisplayCards cardList={price_list} color={"#0b5585"}/>
         <DynamicStockCharts stocks={[ticker,'NIFTY 50']} metric="return" />
        </div>
    )
}
function Risk({risk1,risk2,ticker}) {
    // Convert to list of dictionaries
    if (!risk1 || !risk1.columns || !risk1.data || !risk1.data[0]) {
            // console.log("PRICE LIST",data)
                    console.log("PRICE Columns",risk1.columns)
            // console.log("PRICE DATA",data[0])
            // console.log("PRICE LIST",data)

        return <p>Loading stock data...</p>;
    }
    const price_list = risk1?.columns.map((column, index) => ({
      title: column,
      value: risk1.data[0][index],
      change: null
    }));

    console.log("BETA",risk2)
      return (
    <div className="risk-container">
      <h2>Risk Indicators for {ticker}</h2>

      {/* Beta Gauge */}
      <Plot
        data={[
          {
            type: "indicator",
            mode: "gauge+number",
            value: risk2.beta,
            title: { text: "Beta" },
            gauge: { axis: { range: [0, 2] }, bar: { color: "blue" } },
          },
        ]}
        layout={{ width: 300, height: 300 }}
      />

      {/* Volatility Gauge */}
      <Plot
        data={[
          {
            type: "indicator",
            mode: "gauge+number",
            value: risk2.volatility,
            title: { text: "Volatility (%)" },
            gauge: { axis: { range: [0, 100] }, bar: { color: "orange" } },
          },
        ]}
        layout={{ width: 300, height: 300 }}
      />

      {/* Heatmap for Max Drawdown & Max Loss */}
      <Plot
        data={[
          {
            z: [[risk2.max_drawdown, risk2.max_loss]],
            x: ["Max Drawdown (%)", "Max Loss (%)"],
            y: ["Risk"],
            type: "heatmap",
            colorscale: "RdYlGn",
          },
        ]}
        layout={{ title: "Max Drawdown & Max Loss Heatmap", width: 500, height: 300 }}
      />
     <DisplayCards cardList={price_list.slice(2)} color={"#0b5585"}/>
    </div>
  );
    // return(
    //     <div>
    //     <DisplayCards cardList={price_list} color={"#0b5585"}/>
    //     </div>
    // );
}

const Summary = ({data}) => {
  // const stockData = useContext(StockContext);
  const subSections = ["Stock Snapshot", "Candlestick Chart", "Performance vs Benchmark", "Risk Indicators"];
  const [activeSubTab, setActiveSubTab] = useState(subSections[0]);
  console.log("SUMMARY DATA  RECVD" , data);
  // if (!stockData) return <p>Loading stock data...</p>;

  const renderContent = () => {

    switch (activeSubTab) {
      case "Stock Snapshot":
        return  data ? (<div align={"center"}>
      {/*<StockSnapshot data={JSON.parse(data.price_list)} ticker={data.symbol} />*/}
      <StockSnapshot data={data} ticker={data.symbol} />
            </div>) : (
                <p>Loading data...</p>
              );
      case "Candlestick Chart":
        return data ? (<div align={"center"} style={{height:"700px"}}>
            <StockGraph data={data.symbol}/>
                </div>): (
                <p>Loading data...</p>
              );
      case "Performance vs Benchmark":
        return data ? (<div align={"center"} style={{height:"700px"}}>
      <Benchmarks data={JSON.parse(data.return_list)} ticker={data.symbol} />
                </div>) : (
                <p>Loading data...</p>
              );
      case "Risk Indicators":
        return data ? (<div align={"center"}>
        {/*<Risk data={JSON.parse(data.risk_list)} ticker={data.symbol}/>*/}
        <Risk risk1={JSON.parse(data.risk_list)} risk2={data.risk_n} ticker={data.symbol}/>
        </div>) : (
                <p>Loading data...</p>
              );
      default:
        return <div>Select a tab to view content.</div>;
    }
  };

  return (
    <div className="section-container">
      {/* Vertical Sidebar */}
      <div className="sidebar">
        {subSections.map((tab) => (
          <button
            key={tab}
            className={`side-tab ${activeSubTab === tab ? "active" : ""}`}
            onClick={() => setActiveSubTab(tab)}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* Content Display */}
      <div className="content">
        {/*<h2>{activeSubTab}</h2>*/}
        {/*<p>Displaying data for {activeSubTab}...</p>*/}
        {renderContent()}
      </div>
    </div>
  );
};

export default Summary;

